module.exports = __webpack_public_path__ + "eced8e5fc534c923b1cf18ea619dcdc2.svg";